import FormField from '../swedish-private-v2/form-field';
import PersonalDetailsAutoFill from '../swedish-private-v2/personal-details-autofill';
import Terms from '../swedish-private-v2/terms';
import { Marketing } from '../swedish-private-v2/marketing';
import { Heading } from '../../common/form/form-parts';
import { AutoFilledPersonalDetails } from './auto-filled-personal-details';
import { ManualPersonalDetails } from './manual-personal-details';
import { Button } from 'tradera/components/atoms/button/button';
import Personnummer from 'personnummer';
import { FormFooterLogo } from 'tradera/apps/registration/components/common/form/form-footer-logo';
import { AliasSuggestions } from '../../common/alias-suggestions';

export const SwedishPrivateFormStep2 = ({
    form,
    onNavigate,
    onChangeAcceptsTerms,
    acceptsTerms,
    isNativeAppContext,
    termsError
}) => {
    const autoFilled =
        !form.autoFillFailed &&
        !form.hasAnyFieldSetFromUserInput(
            PersonalDetailsAutoFill.manuallyFilledFields
        );
    const addressValid = form.isValid(PersonalDetailsAutoFill.autoFilledFields);
    const showAutoFilledPersonalDetails = autoFilled && addressValid;
    const showManualPersonalDetails = !autoFilled || !addressValid;
    const personalNumber = form.fields['PersonalNumber'];
    const age = Personnummer.parse(personalNumber.value).getAge();
    const isUnderage = age < 18;
    return (
        <>
            <div />
            <div>
                <Heading>Snart klar!</Heading>
                <FormField
                    form={form}
                    field="Alias"
                    placeholder="Välj ett användarnamn (publikt)"
                    hint="Ditt användarnamn visas för andra när du lägger bud, köper eller säljer på Tradera."
                    containerClassName="mt-2 mb-3"
                />
                <AliasSuggestions
                    alias={form.get('Alias')}
                    email={form.get('EmailAddress')}
                    firstName={form.get('FirstName')}
                    lastName={form.get('LastName')}
                    onSelect={(alias) => form.setFromUserInput('Alias', alias)}
                />
                {showAutoFilledPersonalDetails && (
                    <AutoFilledPersonalDetails form={form} />
                )}
                {showManualPersonalDetails && (
                    <ManualPersonalDetails form={form} />
                )}
                <Terms
                    onChange={onChangeAcceptsTerms}
                    accepts={acceptsTerms}
                    termsError={termsError}
                />
                <Marketing isDefaultChecked={!isUnderage} />
                <div className="text-center">
                    <Button
                        theme="primary"
                        fluid
                        className="my-2"
                        onClick={onNavigate}
                        disabled={!acceptsTerms}
                        data-register-submit="">
                        Registrera
                    </Button>
                </div>
            </div>
            <div className="text-center mb-4">
                {!isNativeAppContext && (
                    <div className={'mb-4'}>
                        Har du hamnat fel?{' '}
                        <a href="/">Gå tillbaka till Tradera</a>
                    </div>
                )}
                <FormFooterLogo />
            </div>
        </>
    );
};
